export default "__VITE_ASSET___a0_76T$__"